/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Toast_Account_Needed_DescriptionInputs */

const en_auth_login_toast_account_needed_description = /** @type {(inputs: Auth_Login_Toast_Account_Needed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up first to create an account.`)
};

const pl_auth_login_toast_account_needed_description = /** @type {(inputs: Auth_Login_Toast_Account_Needed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najpierw zarejestruj się, aby utworzyć konto.`)
};

/**
* | output |
* | --- |
* | "Sign up first to create an account." |
*
* @param {Auth_Login_Toast_Account_Needed_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_login_toast_account_needed_description = /** @type {((inputs?: Auth_Login_Toast_Account_Needed_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Toast_Account_Needed_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_login_toast_account_needed_description(inputs)
	return en_auth_login_toast_account_needed_description(inputs)
});